/**
 * Allowed semver change types in this app.
 * - INITIAL: pure-create flow. Always emits '1.0.0' regardless of currentVersion.
 * - PATCH / MINOR / MAJOR: bump the corresponding semver component.
 */
export const VALID_CHANGE_TYPES = Object.freeze(['INITIAL', 'PATCH', 'MINOR', 'MAJOR']);

/**
 * Compute the next semver string given the current version and a change type.
 *
 * Returns '' (empty string) when:
 *   - changeType is not one of VALID_CHANGE_TYPES, or
 *   - currentVersion is missing / not strict M.m.p (PATCH | MINOR | MAJOR only — INITIAL ignores currentVersion).
 *
 * Callers MUST treat '' as a hard error and refuse to submit.
 *
 * @param {string | undefined} currentVersion
 * @param {'INITIAL' | 'PATCH' | 'MINOR' | 'MAJOR'} changeType
 * @returns {string}
 */
export function computeNextVersion(currentVersion, changeType) {
	if (changeType === 'INITIAL') return '1.0.0';
	if (!currentVersion || !/^\d+\.\d+\.\d+$/.test(currentVersion)) return '';
	const [maj, min, pat] = currentVersion.split('.').map(Number);
	if (changeType === 'PATCH') return `${maj}.${min}.${pat + 1}`;
	if (changeType === 'MINOR') return `${maj}.${min + 1}.0`;
	if (changeType === 'MAJOR') return `${maj + 1}.0.0`;
	return '';
}
